import { render, staticRenderFns } from "./CashiersSettingsPage.vue?vue&type=template&id=2eae65c6&scoped=true&"
import script from "./CashiersSettingsPage.vue?vue&type=script&lang=js&"
export * from "./CashiersSettingsPage.vue?vue&type=script&lang=js&"
import style0 from "./CashiersSettingsPage.vue?vue&type=style&index=0&id=2eae65c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eae65c6",
  null
  
)

export default component.exports